import uniqueId from 'lodash.uniqueid';
// ##### Komarov 2025-07-12
import React, { useEffect } from 'react';
import getIcon from '../helpers/getIcon';
// ##### 24-05-10 Komarov
import { useDispatch, useSelector } from 'react-redux';
import { ReactSearchAutocomplete } from 'react-search-autocomplete';
import { makeItemsArray } from '../../../../../helpers/makeItemsArray';
import { saveHotelsContext } from '../../../../../Redux/actions';

// ##### Komarov 2025-07-14
const AutocompleteDiv = ({ cityHotelInput }) => {
  const cityOrHotelNameOpened = useSelector(
    state => state.hotelsContext.cityOrHotelNameOpened
  );
  // ##### Komarov 2025-08-05
  const locale = useSelector(state => state.language);

  // ##### Komarov 2025-07-12
  useEffect(() => {
    // ##### 24-05-15 Komarov
    if (cityOrHotelNameOpened && cityHotelInput.current) {
      cityHotelInput.current.firstChild.firstChild.style.cssText =
        'font-weight: bold;';
      cityHotelInput.current.querySelector('input').style.cssText =
        'padding: 0; text-align: center;';
      cityHotelInput.current.querySelector('input').focus();
    }
  }, [cityOrHotelNameOpened]);

  const PleaseInputCityorHotelName = useSelector(state => state.pagesRedux[locale]?.PleaseInputCityorHotelName || '');
  /*const smart_translated_hotels = useSelector(
    (state) => state.hotelsContext.smart_translated_hotels
  );*/

  const autocomplete_data_loaded = useSelector(
    state => state.hotels.autocomplete_data_loaded[locale]
  );
  const autocomplete_data = useSelector(
    state => state.hotels.autocomplete_data[locale]
  );
  const autocomplete_data_list =
    autocomplete_data_loaded && makeItemsArray(autocomplete_data.data.data.list);

  const dispatch = useDispatch();

  const handleOnSelect = item => {
    // ##### 24-05-09 Komarov: TODO: Использовать сохранение city_id в другом месте
    localStorage.setItem('city_id', item.city_id);
    localStorage.setItem('hotel_id', item.id);
    localStorage.setItem('isCitySelected', item.city);
    dispatch(
      saveHotelsContext({
        hotelsvalue: item.name,
        selectedItemInfo: item,
        pickedHotelValue: true,
      })
    );
  };

  const formatResult = item => {
    return (
      <div key={uniqueId()}>
        {getIcon(item)} {item.name} {item.city === 0 ? ' city' : null}
      </div>
    );
  };

  return (
    <div
      ref={cityHotelInput}
      style={{ width: '80vw' }}
      data-component="AutocompleteDiv"
    >
      <ReactSearchAutocomplete
        styling={{
          // width: "60vw",
          height: '38px',
          border: 'solid rgb(229, 151, 0)',
          borderRadius: '0.4rem',
          textAlign: 'center',
          hoverBackgroundColor: 'lightblue',
          fontFamily: 'Arial Narrow',
          fontWeight: 'bold',
          fontSize: '18px',
          color: 'darkslategrey',
          placeholderColor: 'grey',
        }}
        showIcon={false}
        autoFocus
        placeholder={PleaseInputCityorHotelName}
        // items={smart_translated_hotels}
        items={autocomplete_data_list}
        onSelect={handleOnSelect}
        formatResult={formatResult}
        resultStringKeyName="name"
        fuseOptions={{
          minMatchCharLength: 2,
        }}
      />
    </div>
  );
};

export default AutocompleteDiv;
